
        var result = require("!!./../../node_modules/raw-loader/index.js!./MIT_LICENSE.md");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


/*****************
 ** WEBPACK FOOTER
 ** ./~/to-string-loader/src/to-string.js!./assets/documents/MIT_LICENSE.md
 ** module id = 392
 ** module chunks = 0
 **/